var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5.971 112.353 513.096 276.769",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 139.613 382.743 L 0 268.555 L 0 259.306 L 139.613 116.019 L 139.613 207.251 L 35.391 263.068 L 35.391 263.695 L 139.613 312.926 L 139.613 382.743 Z",
    style: {
      fill: "rgb(51, 51, 51)",
      strokeWidth: 3
    },
    transform: "matrix(1, 0, 0, 1, 1.1368683772161603e-13, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 500 268.555 L 360.386 382.743 L 360.386 312.926 L 464.934 264.008 L 464.934 263.068 L 360.386 207.251 L 360.386 116.019 L 500 259.306 L 500 268.555 Z",
    style: {
      fill: "rgb(51, 51, 51)",
      strokeWidth: 3
    },
    transform: "matrix(1, 0, 0, 1, 1.1368683772161603e-13, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 482.777 276.865 L 20.421 276.865 L 20.421 256.64 L 482.777 256.64 L 482.777 276.865 Z",
    style: {
      fill: "rgb(51, 51, 51)",
      strokeWidth: 3
    },
    transform: "matrix(1, 0, 0, 1, 1.1368683772161603e-13, 0)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.879687dd6f04b7142309d821897836eb.svg";
export { ForwardRef as ReactComponent };